import { render } from "./FloatArgument.vue?vue&type=template&id=50b92796"
import script from "./FloatArgument.vue?vue&type=script&lang=js"
export * from "./FloatArgument.vue?vue&type=script&lang=js"
script.render = render

export default script